import actions from "./automation-actions";
import getters from "./automation-getters";
import mutations from "./automation-mutations";
import state from "./automation-state";
const automationStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default automationStore;